import React from 'react';
import { motion } from 'framer-motion';
import { Star, Quote } from 'lucide-react';
const testimonials = [{
  initials: 'MT',
  name: 'Maria T.',
  role: 'Spanish Teacher | Miami, Florida',
  text: 'The cultural units completely transformed my most difficult class. My heritage speakers finally feel like their culture belongs in the academic space. And my non-heritage students are genuinely curious about Latin America for the first time.'
}, {
  initials: 'DK',
  name: 'David K.',
  role: 'Spanish Teacher | Chicago, Illinois',
  text: 'The emergency lessons are worth the entire price on their own. I had a sub day with zero notice last month. I sent the package to the substitute, and my students had a productive class without me being there. That has never happened before.'
}, {
  initials: 'RB',
  name: 'Rachel B.',
  role: 'Spanish Teacher | Sydney, Australia',
  text: 'The conversation cards changed everything. I used to dread speaking activities because the room would go silent. Now students are actually arguing about which Spanish-speaking country has the best food. In Spanish. Voluntarily.'
}, {
  initials: 'TW',
  name: 'Tom W.',
  role: 'Spanish Teacher | Vancouver, Canada',
  text: 'The assessments and rubrics pack gave me my Sundays back. I used to spend four hours building assessments every time I finished a unit. Now I open the pack, select the right one, and I am done in ten minutes.'
}, {
  initials: 'JA',
  name: 'Jennifer A.',
  role: 'Spanish Teacher | Dallas, Texas',
  text: 'I teach Spanish 1 and Spanish 2 simultaneously in a combined class. I genuinely did not know how to manage two levels with one lesson plan. The differentiated activities in this system solved a problem I had been struggling with for three years.'
}];
export function ExtendedTestimonials() {
  return <section className="py-24 px-4 bg-cream" data-id="element-70">
      <div className="max-w-6xl mx-auto" data-id="element-71">
        <div className="text-center mb-16" data-id="element-72">
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-navy" data-id="element-73">
            What Teachers Who Already Have Spanish Ready™ Are Saying
          </h2>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-74">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className={`bg-white border border-navy/10 p-8 rounded-2xl relative shadow-sm ${i === 4 ? 'md:col-span-2 lg:col-span-1' : ''}`} data-id="element-75">
              <Quote className="absolute top-6 right-6 text-turquoise/10" size={48} data-id="element-76" />

              <div className="flex gap-1 text-gold mb-6" data-id="element-77">
                {[...Array(5)].map((_, j) => <Star key={j} size={16} fill="currentColor" data-id="element-78" />)}
              </div>

              <p className="text-navy-light italic mb-8 relative z-10 leading-relaxed" data-id="element-79">
                "{t.text}"
              </p>

              <div className="flex items-center gap-4 mt-auto" data-id="element-80">
                <div className="w-12 h-12 rounded-full bg-turquoise/10 flex items-center justify-center text-turquoise font-bold text-lg border border-turquoise/30" data-id="element-81">
                  {t.initials}
                </div>
                <div data-id="element-82">
                  <div className="font-bold text-navy" data-id="element-83">{t.name}</div>
                  <div className="text-xs text-turquoise" data-id="element-84">{t.role}</div>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}